import createDataContext from "./createData.context";
import tasksReducer from "../reducers/tasks.reducer";

import {
  addTaskGroup,
  editTaskGroup,
  deleteTaskGroup,
  addTask,
  editTask,
  deleteTask,
  getTaskGroups,
  getTasks,
} from "../actions/tasks.actions";

const initialState = {
  taskGroups: [],
  tasks: [],
  loading: false,
  error: null,
};

export const { Context: TasksContext, Provider: TasksProvider } =
  createDataContext(
    tasksReducer,
    {
      addTaskGroup,
      editTaskGroup,
      deleteTaskGroup,
      addTask,
      editTask,
      deleteTask,
      getTaskGroups,
      getTasks,
    },
    initialState
  );
